import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { MotionDiv } from "../../utils/animations";
import "./home.css";

function CtaSection() {
    return (
        <section id="contacto" className="cta-section">
            <div className="cta-bg" aria-hidden="true">
                <motion.div
                    className="cta-bg-orb cta-bg-orb-1"
                    animate={{ x: [0, 20, 0], y: [0, -15, 0] }}
                    transition={{ duration: 9, repeat: Infinity, ease: "easeInOut" }}
                />
                <motion.div
                    className="cta-bg-orb cta-bg-orb-2"
                    animate={{ x: [0, -15, 0], y: [0, 20, 0] }}
                    transition={{ duration: 11, repeat: Infinity, ease: "easeInOut" }}
                />
            </div>

            <div className="section-container">
                <MotionDiv className="cta-container">
                    <div className="section-tag">¿Listo para empezar?</div>
                    <h2 className="cta-title">
                        Lleva tu proyecto al{" "}
                        <span className="cta-title-gradient">siguiente nivel</span>
                    </h2>
                    <p className="cta-subtitle">
                        Desde auditorías de seguridad hasta plataformas con IA.
                        Construimos soluciones robustas, escalables y seguras.
                    </p>
                    <div className="cta-actions">
                        <motion.a
                            href="https://wa.me/573223089359?text=Hola%2C%20quiero%20hablar%20sobre%20mi%20proyecto"
                            className="btn-primary btn-lg"
                            target="_blank"
                            rel="noopener noreferrer"
                            whileHover={{ scale: 1.04, y: -2 }}
                            whileTap={{ scale: 0.98 }}
                        >
                            Hablemos de tu proyecto
                        </motion.a>
                        <Link to="/proyectos" className="btn-secondary btn-lg">
                            Ver proyectos
                        </Link>
                    </div>
                    <div className="cta-trust">
                        <span className="cta-trust-item">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="cta-trust-icon">
                                <path fillRule="evenodd" d="M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z" clipRule="evenodd" />
                            </svg>
                            Seguridad certificada
                        </span>
                        <span className="cta-trust-item">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="cta-trust-icon">
                                <path fillRule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z" clipRule="evenodd" />
                            </svg>
                            IA y datos avanzados
                        </span>
                        <span className="cta-trust-item">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="cta-trust-icon">
                                <path d="M3 4a2 2 0 0 0-2 2v1.161l8.441 4.221a1.25 1.25 0 0 0 1.118 0L19 7.162V6a2 2 0 0 0-2-2H3Z" />
                                <path d="m19 8.839-7.77 3.885a2.75 2.75 0 0 1-2.46 0L1 8.839V14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.839Z" />
                            </svg>
                            Soporte dedicado
                        </span>
                    </div>
                </MotionDiv>
            </div>
        </section>
    );
}

export default CtaSection;
